import React from 'react'
import SingleChoice from './partials/singleChoice';
import TextUpload from './partials/TextUpload';
import YesNoUpload from './partials/YesNoUpload';
import YesNoText from './partials/YesNoText';
import MultipleChoice from './partials/multiChoice';
import UnitText from './partials/UnitText';
import NPS from './partials/NPS';
import YesNoSingleChoice from './partials/YesNoSingleChoice';
import './style.scss'
import { Spinner } from 'react-bootstrap';


const QuestionBox = ({ currentQuestion, handleAnswer, uploadLoading, setUploadLoading, answers, handleMultiQuesAnswer, handleNext, nextDisabled, loading, currentIndex}) => {


    // const isQuestionAnswered = answersDone?.[currentQuestion?.refCode];
    // const isRequired = currentQuestion?.isRequired;
    // const isAllRequiredFilled = (isQuestionAnswered || !isRequired ? Object.keys(requiredAnswersDone)?.length : (Object.keys(requiredAnswersDone)?.length)+1)  === requiredQuestions?.length;
    
    return (
        <div className='question__and__options__box'>
            <div className='question__box__header'>
                <h5 dangerouslySetInnerHTML={{ __html: currentQuestion?.criteria ?? '' }} />
                {/* <h5>
                    {currentQuestion?.criteria ?? ''}
                </h5> */}
            </div>
            <div className='question__box__description'>
                <div className='question__sub__box__descripton'>
                    {currentQuestion?.responseType === "SC" && (
                        <SingleChoice
                            data={currentQuestion}
                            handleAnswer={handleAnswer}
                            answers={answers}
                            uploadLoading={uploadLoading}
                            setUploadLoading={setUploadLoading}
                            currentIndex={currentIndex}
                        />
                    )}

                    {currentQuestion?.responseType?.toUpperCase() === "TEXT" || currentQuestion?.responseType?.toUpperCase() === "NUM" ? (
                        <TextUpload
                            data={currentQuestion}
                            handleAnswer={handleAnswer}
                            answers={answers}
                            uploadLoading={uploadLoading}
                            setUploadLoading={setUploadLoading}
                            currentIndex={currentIndex}
                        />
                    ) : ""}

                    {(currentQuestion?.responseType === "YN") && (
                        <YesNoUpload
                            uploadLoading={uploadLoading}
                            setUploadLoading={setUploadLoading}
                            data={currentQuestion}
                            handleAnswer={handleAnswer}
                            answers={answers}
                            currentIndex={currentIndex}
                        />
                    )}

                    {(currentQuestion?.responseType === "YN+Text" || currentQuestion?.responseType === "YN+AL-Text") && (
                        <YesNoText
                            data={currentQuestion}
                            handleAnswer={handleAnswer}
                            answers={answers}
                            uploadLoading={uploadLoading}
                            setUploadLoading={setUploadLoading}
                            currentIndex={currentIndex}
                        />
                    )}

                    {currentQuestion?.type === "multiQues" && (
                        <MultipleChoice
                            data={currentQuestion}
                            handleAnswer={handleMultiQuesAnswer}
                            answers={answers}
                            currentIndex={currentIndex}
                        />
                    )}

                    {currentQuestion?.responseType === "YN + SC" && (
                        <YesNoSingleChoice
                            data={currentQuestion}
                            handleAnswer={handleAnswer}
                            answers={answers}
                            currentIndex={currentIndex}
                        />
                    )}

                    {currentQuestion?.responseType === "SC-UNIT+TEXT" && (
                        <UnitText
                            data={currentQuestion}
                            handleAnswer={handleAnswer}
                            answers={answers}
                            currentIndex={currentIndex}
                        />
                    )}

                    {currentQuestion?.responseType === "NPS" && (
                        <NPS
                            data={currentQuestion}
                            handleAnswer={handleAnswer}
                            answers={answers}
                            uploadLoading={uploadLoading}
                            setUploadLoading={setUploadLoading}
                            currentIndex={currentIndex}
                        />
                    )}
                    {/* {isLastQuestion ? <div className='next__and__skip'>
                        <button className='mw-100' disabled={nextDisabled || loading || uploadLoading || !isAllRequiredFilled} onClick={() => handleNext(false, false, 'COMPLETED')}>
                            SUBMIT ASSESSMENT
                        </button>
                        <div className='submit__points'>
                            <ul>
                                <li>
                                The "Submit Assessment" button will activate once all required questions (*) are answered.
                                </li>
                                <li>
                                Unanswered required questions are marked with a greyed-out check circle in the left-hand navigation bar.
                                </li>
                                <li>
                                Please review your responses carefully before submitting. Submissions are final, and answers cannot be edited afterward.
                                </li>
                            </ul>
                            </div>
                    </div> :
                        
                    } */}
                    <div className='next__and__skip'>
                            <button disabled={nextDisabled || loading || uploadLoading} onClick={() => handleNext(false)}>
                                {loading ? <Spinner animation="border" role="status" /> : "NEXT"}
                            </button>
                            <button onClick={() => handleNext(true)} className='skip__btn'>
                                Skip for Now
                            </button>
                        </div>
                </div>
            </div>
        </div>
    )
}

export default QuestionBox